import route from "@/router";
import store from "@/store/store";
import { DO_LOGOUT } from "@/store/actions";

export const success = (response) => {  
    return response;
}

export const error = (res) => {
    if (res.response.status === 401 || res.response.status === 400) {
        store.dispatch(DO_LOGOUT);        
        route.push({ name: 'login', params: { error: "Sessão expirou" } });
        return { data: { statusCode: 200, ...res.response.data } };
    };    
    return res;
}
